import { render } from "./DioVoid.vue?vue&type=template&id=6df3d99d&ts=true"
import script from "./DioVoid.vue?vue&type=script&lang=ts"
export * from "./DioVoid.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__